import React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { colors } from '@lib/colors'

interface FABProps {
  onPress: () => void
  icon: JSX.Element
}

export default function (props: FABProps) {
  const { onPress, icon } = props

  return (
    <Pressable style={styles.container} onPress={onPress}>
      <View style={styles.button}>
        {icon}
      </View>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 40,
    right: 25,
  },
  button: {
    backgroundColor: colors.blue[600],
    borderRadius: 30,
    width: 60,
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
